module.exports = __webpack_public_path__ + "static/img/07054B_1_2_R_20211030_fit.b710677.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/07054B_1_2_R_20211030_fit.png
// module id = /piY
// module chunks = 0